import React, { useState } from 'react';
import { Textarea } from '@frontend/shadcn/components/ui/textarea';
import { cn } from '@frontend/shadcn/lib/utils';

interface CollapsibleTextareaProps {
  value: string;
  onChange: (value: string) => void;
  addButtonLabel?: string;
  removeButtonLabel?: string;
  placeholder?: string;
  className?: string;
  rows?: number;
  initialShow?: boolean;
  show?: boolean; // controlled mode
  onToggle?: (show: boolean) => void;
  renderInput?: (props: {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    rows?: number;
    className?: string;
  }) => React.ReactNode;
}

export function CollapsibleTextarea({
  value,
  onChange,
  addButtonLabel = 'Add Description',
  removeButtonLabel = 'Remove',
  placeholder = 'Add Description',
  className,
  rows = 3,
  initialShow,
  show: controlledShow,
  onToggle,
  renderInput
}: CollapsibleTextareaProps) {
  const [uncontrolledShow, setUncontrolledShow] = useState(
    initialShow !== undefined ? initialShow : !!value
  );
  const show = controlledShow !== undefined ? controlledShow : uncontrolledShow;

  function handleToggle() {
    const nextShow = !show;
    if (controlledShow === undefined) setUncontrolledShow(nextShow);
    if (onToggle) onToggle(nextShow);
    if (!nextShow) onChange('');
  }

  return (
    <div className={cn('w-full', className)}>
      <button
        type="button"
        className="text-grey-6 flex items-center gap-1 hover:text-grey-7 transition-colors"
        onClick={handleToggle}
      >
        {show ? '-' : '+'} <span className="underline">{show ? removeButtonLabel : addButtonLabel}</span>
      </button>
      {show && (
        <div className="flex flex-col gap-2 mt-2">
          {renderInput ? (
            renderInput({ value, onChange, placeholder, rows, className: 'border-[#E5E7EB]' })
          ) : (
            <Textarea
              placeholder={placeholder}
              value={value}
              onChange={(e) => onChange(e.target.value)}
              rows={rows}
              className="border-grey-2 rounded-lg"
            />
          )}
        </div>
      )}
    </div>
  );
}
